import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";

export default function CrudForm({ fields, form, handleChange, regionOptions, provinceOptions, countryOptions, comarcaOptions, setForm }) {
    // Filtrar regiones por país seleccionado
    const filteredRegionOptions = form.idCountry
        ? regionOptions?.filter(region => region.idCountry === form.idCountry)
        : regionOptions;

    // Filtrar provincias por región seleccionada
    const filteredProvinceOptions = form.idRegion
        ? provinceOptions?.filter(province => province.idRegion === form.idRegion)
        : provinceOptions;

    // Filtrar comarcas por provincia seleccionada
    const filteredComarcaOptions = form.idProvince
        ? comarcaOptions?.filter(comarca => comarca.idProvince === form.idProvince)
        : comarcaOptions;

    return (
        <>
            {fields.map(f => (
                f.name === "idCountry" && countryOptions && !f.hiddenCol ? (
                    <Box key={f.name} sx={{ mt: 1, mb: 1 }}>
                        {/* País siempre habilitado */}
                        <label style={{ fontSize: 14, marginBottom: 4, display: "block" }}>{f.label}</label>
                        <Select
                            size="small"
                            name={f.name}
                            value={form[f.name] || ""}
                            onChange={handleChange}
                            fullWidth
                            displayEmpty
                        >
                            <MenuItem value="">
                                <em>Seleccione un país</em>
                            </MenuItem>
                            {countryOptions.map(country => (
                                <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                            ))}
                        </Select>
                    </Box>
                ) : f.name === "idRegion" && regionOptions && !f.hiddenCol ? (
                    <Box key={f.name} sx={{ mt: 1, mb: 1 }}>
                        {/* Comunidad deshabilitada si país no seleccionado */}
                        <label style={{ fontSize: 14, marginBottom: 4, display: "block" }}>{f.label}</label>
                        <Select
                            size="small"
                            name={f.name}
                            value={form[f.name] || ""}
                            onChange={handleChange}
                            fullWidth
                            displayEmpty
                            disabled={!form.idCountry}
                        >
                            <MenuItem value="">
                                <em>Seleccione una comunidad</em>
                            </MenuItem>
                            {(filteredRegionOptions || []).map(region => (
                                <MenuItem key={region.id} value={region.id}>{region.name}</MenuItem>
                            ))}
                        </Select>
                    </Box>
                ) : f.name === "idProvince" && provinceOptions && !f.hiddenCol ? (
                    <Box key={f.name} sx={{ mt: 1, mb: 1 }}>
                        {/* Provincia deshabilitada si comunidad no seleccionada */}
                        <label style={{ fontSize: 14, marginBottom: 4, display: "block" }}>{f.label}</label>
                        <Select
                            size="small"
                            name={f.name}
                            value={form[f.name] || ""}
                            onChange={handleChange}
                            fullWidth
                            displayEmpty
                            disabled={!form.idRegion}
                        >
                            <MenuItem value="">
                                <em>Seleccione una provincia</em>
                            </MenuItem>
                            {(filteredProvinceOptions || []).map(province => (
                                <MenuItem key={province.id} value={province.id}>{province.name}</MenuItem>
                            ))}
                        </Select>
                    </Box>
                ) : f.name === "idComarca" && comarcaOptions && !f.hiddenCol ? (
                    <Box key={f.name} sx={{ mt: 1, mb: 1 }}>
                        {/* Comarca deshabilitada si provincia no seleccionada */}
                        <label style={{ fontSize: 14, marginBottom: 4, display: "block" }}>{f.label}</label>
                        <Select
                            size="small"
                            name={f.name}
                            value={form[f.name] || ""}
                            onChange={handleChange}
                            fullWidth
                            displayEmpty
                            disabled={!form.idProvince}
                        >
                            <MenuItem value="">
                                <em>Seleccione una comarca</em>
                            </MenuItem>
                            {(filteredComarcaOptions || []).map(comarca => (
                                <MenuItem key={comarca.id} value={comarca.id}>{comarca.name}</MenuItem>
                            ))}
                        </Select>
                    </Box>
                ) : (
                    f.name !== "idCountry" && f.name !== "idRegion" && f.name !== "idProvince" && f.name !== "idComarca" && !f.hiddenCol && (
                        <TextField
                            key={f.name}
                            margin="dense"
                            size="small"
                            label={f.label}
                            name={f.name}
                            value={form[f.name] || ""}
                            onChange={handleChange}
                            fullWidth
                            type={f.type || "text"}
                            InputLabelProps={{ shrink: true }}
                        />
                    )
                )
            ))}
            <Box sx={{ display: "flex", alignItems: "center", mt: 2, mb: 1 }}>
                <span style={{ marginRight: 12 }}>Activo</span>
                <Switch
                    checked={Boolean(Number(form.isActive ?? 1))}
                    onChange={e => setForm({ ...form, isActive: e.target.checked ? 1 : 0 })}
                    name="isActive"
                    color="primary"
                />
            </Box>
        </>
    );
}
